import { Link } from 'react-router-dom';

/**
 * 404 not-found page. Keeps the brand voice light and pushes visitors back
 * into the shop or the custom-request flow so they don't just bounce.
 */
const NotFound = () => {
  return (
    <main
      data-testid="not-found-page"
      className="min-h-screen bg-brand-cream flex items-center justify-center px-6 py-16 relative overflow-hidden"
    >
      {/* Orange halo behind Teeodore */}
      <div
        aria-hidden
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[40rem] h-[40rem] rounded-full opacity-20 blur-3xl pointer-events-none"
        style={{ background: 'radial-gradient(circle, #FF6600 0%, transparent 60%)' }}
      />

      <div className="relative max-w-5xl w-full grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-14 items-center">
        {/* Teeodore, shrugging his way through your mistake */}
        <div className="flex justify-center md:justify-end order-1 md:order-2">
          <img
            src="/brand/teeodore.png"
            alt="Teeodore couldn't find the page"
            data-testid="not-found-mascot"
            className="w-full max-w-[340px] md:max-w-[420px] select-none drop-shadow-[0_20px_45px_rgba(255,102,0,0.35)]"
            draggable={false}
          />
        </div>

        {/* Message + escape hatches */}
        <div className="order-2 md:order-1 max-w-xl">
          <div className="inline-flex items-center gap-2 mb-5 px-3 py-1.5 rounded-full bg-black text-brand-orange">
            <span className="font-display font-black text-[10px] tracking-[0.32em] uppercase">
              404 · Nothing here
            </span>
          </div>
          <h1 className="font-display font-black text-5xl sm:text-6xl md:text-7xl leading-[0.9] text-black tracking-tight mb-4">
            Even Teeodore <span className="text-brand-orange">can&rsquo;t find</span> that shirt.
          </h1>
          <p className="font-body text-base sm:text-lg text-black/70 leading-relaxed mb-8">
            The page you&rsquo;re looking for either moved, retired, or never existed in the
            first place. But hey &mdash; while you&rsquo;re here, we&rsquo;ve got shirts.
          </p>
          <div className="flex flex-wrap gap-3">
            <Link
              to="/"
              data-testid="not-found-home-btn"
              className="inline-flex items-center gap-2 font-display font-black text-xs uppercase tracking-[0.24em] px-6 py-3.5 rounded-full bg-black text-brand-orange border-2 border-black hover:bg-brand-orange hover:text-black transition-colors"
            >
              ← Back home
            </Link>
            <Link
              to="/#shop"
              data-testid="not-found-shop-btn"
              className="inline-flex items-center gap-2 font-display font-black text-xs uppercase tracking-[0.24em] px-6 py-3.5 rounded-full bg-white text-black border-2 border-black hover:bg-brand-orange hover:border-brand-orange transition-colors"
            >
              Browse the shop →
            </Link>
            <Link
              to="/#custom"
              data-testid="not-found-custom-btn"
              className="inline-flex items-center gap-2 font-display font-black text-xs uppercase tracking-[0.24em] px-6 py-3.5 rounded-full bg-white text-black border-2 border-black hover:bg-brand-orange hover:border-brand-orange transition-colors"
            >
              Start a custom shirt →
            </Link>
          </div>
        </div>
      </div>
    </main>
  );
};

export default NotFound;
